import { useHistory, useParams } from 'react-router-dom'

import BodySection from './BodySection'
import React from 'react'
import { components } from 'cng-web-lib'

const {
  form: { CngViewForm }
} = components

function ManageBookingReviewPage(props) {
  const { id } = useParams()
  const history = useHistory()
  const {showNotification} = props
  
  function onSubmit(data) {
    console.log('submit edit')
  }

  return (

    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <BodySection.FormFields
          disabled={false}
          {...props}
        />
      }
      formikProps={{
        ...BodySection.formikProps,
        onSubmit: onSubmit
      }}

    />

  )
}

export default ManageBookingReviewPage
